import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { playerStorage } from 'components/widgets/Player/storages';

/**
 * Сlearing the error on changing routing
 */
export function useCleanUpErrorOnUrlChange({
  isError,
  onClear,
  clearError,
}: {
  isError: boolean;
  onClear: (() => void) | undefined;
  clearError: () => void;
}) {
  const location = useLocation();

  useEffect(() => {
    if (isError) {
      if (onClear) {
        onClear();
      }

      clearError();

      // cleanup connectivity timers
      if (playerStorage.previousPlayerError) {
        playerStorage.clearPreviousPlayerError();
        playerStorage.clearIsNoConnectionErrorFired();
      }
    }
  }, [location.pathname]);
}
